module.exports = __webpack_public_path__ + "img/ShafiqiHaji-ZhyaniMn.45787ace.jpg";